var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBizIndividual(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.171,
    height: 39.521,
    fill: "none",
    stroke: "#216bc5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed7015"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eda215"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7.086 -7.76)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    transform: "translate(7.086 7.76)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17 13)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.361 0.32)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.06 0.642)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.6025390625 17.61936187744141 C 5.160079002380371 17.61936187744141 3.789819002151489 16.82300186157227 2.744168996810913 15.37699222564697 C 1.619429111480713 13.82160186767578 0.9999990463256836 11.7050724029541 0.9999990463256836 9.417302131652832 C 0.9999990463256836 7.027162075042725 1.112369060516357 4.580242156982422 1.927569031715393 2.874392032623291 C 2.443719148635864 1.79432201385498 3.489909172058105 0.3584020733833313 6.6025390625 0.3584020733833313 C 9.715168952941895 0.3584020733833313 10.76135921478271 1.79432201385498 11.27750873565674 2.874392032623291 C 12.09270858764648 4.580242156982422 12.20507907867432 7.027162075042725 12.20507907867432 9.417302131652832 C 12.20507907867432 11.7050724029541 11.58564949035645 13.82160186767578 10.46090888977051 15.37699222564697 C 9.41525936126709 16.82300186157227 8.044999122619629 17.61936187744141 6.6025390625 17.61936187744141 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6.6025390625 1.358402252197266 C 5.523108959197998 1.358402252197266 4.658768653869629 1.547142028808594 4.033538818359375 1.91937255859375 C 3.517438888549805 2.226632118225098 3.13494873046875 2.667112350463867 2.829838752746582 3.305572509765625 C 2.100528717041016 4.831682205200195 1.999999046325684 7.144882202148438 1.999999046325684 9.417302131652832 C 1.999999046325684 11.49634170532227 2.552068710327148 13.40477180480957 3.554498672485352 14.79102230072021 C 4.407089233398438 15.97004222869873 5.489569187164307 16.61936187744141 6.6025390625 16.61936187744141 C 7.715508937835693 16.61936187744141 8.797988891601562 15.97004222869873 9.650579452514648 14.79102230072021 C 10.65300941467285 13.40477180480957 11.20507907867432 11.49634170532227 11.20507907867432 9.417302131652832 C 11.20507907867432 7.144882202148438 11.10454940795898 4.831682205200195 10.37523937225342 3.305572509765625 C 9.915109634399414 2.34271240234375 9.107038497924805 1.358402252197266 6.6025390625 1.358402252197266 M 6.6025390625 -0.6415977478027344 C 12.67177867889404 -0.6415977478027344 13.20507907867432 4.231601715087891 13.20507907867432 9.417302131652832 C 13.20507907867432 14.60299205780029 10.24901962280273 18.61936187744141 6.6025390625 18.61936187744141 C 2.956059455871582 18.61936187744141 -9.5367431640625e-07 14.60299205780029 -9.5367431640625e-07 9.417302131652832 C -9.5367431640625e-07 4.231601715087891 0.533299446105957 -0.6415977478027344 6.6025390625 -0.6415977478027344 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.559,19.816h0A5.687,5.687,0,0,0,16.3,17.061c1.969-3.068,2.354-6.094,2.354-9.907,0,0-.183-6.832-7.09-6.832",
    transform: "translate(3.162 -0.321)",
    fill: "none",
    stroke: "#216bc5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.258,19.816h0a5.687,5.687,0,0,1-4.744-2.755c-1.968-3.068-2.354-6.094-2.354-9.907,0,0,.184-6.832,7.09-6.832",
    transform: "translate(1.463 -0.321)",
    fill: "none",
    stroke: "#216bc5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.765,14.08c.005.231,0,.452-.013.663a4.123,4.123,0,0,1-3.214,3.73l-3.463.868a5.5,5.5,0,0,0-3.607,3.446A5.682,5.682,0,0,0,1.173,24.1L.361,31.128H11.752",
    transform: "translate(-0.361 4.267)",
    fill: "none",
    stroke: "#216bc5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.088,14.08c-.005.231,0,.452.013.663a4.123,4.123,0,0,0,3.214,3.73l3.463.868a5.5,5.5,0,0,1,3.607,3.446A5.681,5.681,0,0,1,24.68,24.1l.812,7.027H15.208",
    transform: "translate(3.957 4.267)",
    fill: "none",
    stroke: "#216bc5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBizIndividual);
export default __webpack_public_path__ + "static/media/biz-individual.0934295ffb9a03172689e77602d2e513.svg";
export { ForwardRef as ReactComponent };